import React from 'react'
import { ImageList, ImageListItem, Stack } from '@mui/material'
import image from '../../../assets/images/Estacionario.jpg'
import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'
export const ListImagesEvidence = () => {
  const Image = styled('img')(() => ({
    borderRadius: 20,
    width: '100%',

    height: 150,
    objectFit: 'cover',
    cursor: 'pointer',
    marginRight: 15,
    paddingBottom: 10,
    marginBottom: 15,
  }))
  const navigate = useNavigate()
  const handleNavigate = () => {
     navigate(`/dashboard/evidence`)
  }
  return (
    // <Stack direction="row" spacing={2} sx={{ display: 'flex', flexWrap: 'nowrap', overflow: 'hidden', overflowX: 'auto' }}>
    //   <ImageListItem>
    //     <Image src={ image } alt="global" />
    //   </ImageListItem>
    // </Stack>
    <div style={{ display: 'flex', flexWrap: 'nowrap', overflow: 'hidden', overflowX: 'auto' }}>
      <Image src={ image } alt="global" onClick={handleNavigate}/>
      <Image src={ image } alt="global" onClick={handleNavigate}/>
      <Image src={ image } alt="global" onClick={handleNavigate}/>
      <Image src={ image } alt="global" onClick={handleNavigate}/>
      <Image src={ image } alt="global" onClick={handleNavigate}/>
      <Image src={ image } alt="global" onClick={handleNavigate}/>
      <Image src={ image } alt="global" onClick={handleNavigate}/>
    </div>
  )
}
